import React, { useEffect } from "react";
import { api, userService } from "../../_services";

const IntuitRedirect = () => {
  const currentUser = userService.getLoggedInUser();
  const [code, setCode] = React.useState(null);
  const [token, setToken] = React.useState(null);
  const [realmId, setRealmId] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code"); // "12345"
    const realmId = params.get("realmId"); // "67890"
    setCode(code);
    setRealmId(realmId);
    loadToken(code, realmId);
  }, []);

  const loadToken = async (code, realmId) => {
    setIsLoading(true);
    let t = await api.callbackIntuit(currentUser.entityId, code, realmId);
    setToken(t);
    setIsLoading(false);
  };

  return (
    <>
      {isLoading && <p>Loading...</p>}
      {!isLoading && (
        <p>Your QuickBooks Integration has been successfully set up!</p>
      )}
      {/* {code && <p>Code: {code}</p>}
      {token && <p>Token: {token?.accessToken}</p>}
      {token && <p>Refresh Token: {token?.refreshToken}</p>} */}
    </>
  );
};

export default IntuitRedirect;
